type NetcoreEventProps = Record<string, string | number | null | unknown>;

export const trackEventInNetcore = (
  eventName: string,
  properties: NetcoreEventProps
): void => {
  try {
    if (
      typeof window !== 'undefined' &&
      typeof window.smartech === 'function'
    ) {
      window.smartech('dispatch', eventName, properties);
    } else {
      console.error('Netcore SDK not available.');
    }
  } catch (error) {
    console.error('Error sending event to Netcore:', error);
  }
};

export const identifyUserInNetcore = (email: string, phone?: string): void => {
  try {
    if (
      typeof window !== 'undefined' &&
      typeof window.smartech === 'function'
    ) {
      window.smartech('identify', email.trim().toLowerCase());
      if (phone) {
        window.smartech('dispatch', 'update', {
          pk_emailid: email,
          MOBILE: phone,
        });
      }
    } else {
      console.error('Netcore SDK not available for identifying user.');
    }
  } catch (error) {
    console.error('Error in user identification:', error);
  }
};
